module.exports = __webpack_public_path__ + "static/img/pic1-2-2.aa927a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt/pic1-2-2.png
// module id = aFBu
// module chunks = 1